import axios from 'axios';
import { BASE_URL } from './api';

export async function getCampaigns(payload) {
    return axios({
        method: "get",
        url: `${BASE_URL}/campaigns/${payload.endpoint}`,
        headers: {
            'Authorization': `Token ${payload.token}`
        }
    })
    .then(response => {
        return response.data
    })
    .catch(error => console.error(error))

}

export async function createNewCampaign(data, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/campaigns/create_campaign/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    })
}

export async function updateCampaign(campaignID, data, token) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/campaigns/${campaignID}/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    })
}

export async function archiveCampaign(campaignID, data, token) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/campaigns/${campaignID}/`,
        headers: { 
          'Authorization': `Token ${token}`, 
          'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    })
  }